import { render, staticRenderFns } from "./CardDataComparator.vue?vue&type=template&id=bb3c4756&scoped=true"
import script from "./CardDataComparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardDataComparator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardDataComparator.vue?vue&type=style&index=0&id=bb3c4756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c4756",
  null
  
)

export default component.exports